import { render, staticRenderFns } from "./GastosReembolsables.vue?vue&type=template&id=5a6e8fa6&scoped=true&"
import script from "./GastosReembolsables.vue?vue&type=script&lang=js&"
export * from "./GastosReembolsables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e8fa6",
  null
  
)

export default component.exports